import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-display-array',
  template: require('./display-array.component.html'),
  styles: [require('./display-array.component.scss')],
})
export class DisplayArrayComponent {
  @Input() field: string;
  @Input() value: any;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/display-array/display-array.component.ts